import type { CarrierDto } from "@babackapp/private-api-client/types";

// Mirrors CHRONOPOST_ELABEL_SERVICE in
// apps/baback-end/src/modules/carrier-providers/chronopost/chronopost.constants.ts.
// Duplicated as a literal because no shared carrier-constants package exists
// between the backend and the office.
export const CHRONOPOST_ELABEL_SERVICE = "2shopretour-elabel";

export function isChronopostELabel(carrier: CarrierDto): boolean {
  return carrier.preferences.chronopostService === CHRONOPOST_ELABEL_SERVICE;
}
